import { BaseComponent } from './../../../../shared/Components/base/base.component';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BenefeciariesService } from '../../services/benefeciariesComponentService';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { AddbeneficiariesComponent } from '../add-beneficiaries/add-beneficiaries.component';
import { UpdatebeneficiariesComponent } from '../update/update-beneficiaries.component';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';


@Component({
  selector: 'ngx-questions',
  templateUrl: './benefeciaries.component.html',
  styleUrls: ['./benefeciaries.component.scss'],
})
export class BenefeciariesComponent extends BaseComponent implements OnInit {
  constructor(public service: BenefeciariesService, public route: Router, public paging: PagingService,
    private diag: NbDialogService,
    private toast: NbToastrService) {
    super(route, service, paging, '');
  }

  ngOnInit() {
    this.loadEntities();
  }

  add() {
    this.diag.open(AddbeneficiariesComponent).onClose.subscribe(res => {
      if (res === 'true') this.loadEntities();
    });
  }
    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }
  update(serviceRate) {
    const copymodel = {...serviceRate}
    this.diag.open(UpdatebeneficiariesComponent, { context: { sType: copymodel } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.loadEntities();
      }
    });
  }
}
